/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FilterCriteriaInfo,
  ReferentialItemDto,
  TitreDiplomeCertificationEditDto,
  TitreDiplomeCertificationGridDtoPaginatedResults,
  TitreDiplomeCertificationSearchDto,
} from '../models/index';
import {
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoToJSON,
    TitreDiplomeCertificationEditDtoFromJSON,
    TitreDiplomeCertificationEditDtoToJSON,
    TitreDiplomeCertificationGridDtoPaginatedResultsFromJSON,
    TitreDiplomeCertificationGridDtoPaginatedResultsToJSON,
    TitreDiplomeCertificationSearchDtoFromJSON,
    TitreDiplomeCertificationSearchDtoToJSON,
} from '../models/index';

export interface TitreDiplomeCertificationBaseSearchRequest {
    TitreDiplomeCertificationSearchDto?: TitreDiplomeCertificationSearchDto;
}

export interface TitreDiplomeCertificationDeleteTitreDiplomeCertificationRequest {
    id?: number;
}

export interface TitreDiplomeCertificationGetDisplayNameRequest {
    id?: number;
}

export interface TitreDiplomeCertificationGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface TitreDiplomeCertificationGetSelectItemsRequest {
    searchField: string;
}

export interface TitreDiplomeCertificationGetTitreDiplomeCertificationRequest {
    id?: number;
}

export interface TitreDiplomeCertificationSaveTitreDiplomeCertificationRequest {
    TitreDiplomeCertificationEditDto?: TitreDiplomeCertificationEditDto;
}

/**
 * 
 */
export class TitreDiplomeCertificationApi extends runtime.BaseAPI {

    /**
     */
    async titreDiplomeCertificationBaseSearchRaw(requestParameters: TitreDiplomeCertificationBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TitreDiplomeCertificationGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/TitreDiplomeCertification/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TitreDiplomeCertificationSearchDtoToJSON(requestParameters.TitreDiplomeCertificationSearchDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TitreDiplomeCertificationGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async titreDiplomeCertificationBaseSearch(requestParameters: TitreDiplomeCertificationBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TitreDiplomeCertificationGridDtoPaginatedResults> {
        const response = await this.titreDiplomeCertificationBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async titreDiplomeCertificationDeleteTitreDiplomeCertificationRaw(requestParameters: TitreDiplomeCertificationDeleteTitreDiplomeCertificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/TitreDiplomeCertification`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async titreDiplomeCertificationDeleteTitreDiplomeCertification(requestParameters: TitreDiplomeCertificationDeleteTitreDiplomeCertificationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.titreDiplomeCertificationDeleteTitreDiplomeCertificationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async titreDiplomeCertificationGetDisplayNameRaw(requestParameters: TitreDiplomeCertificationGetDisplayNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/TitreDiplomeCertification/GetDisplayName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async titreDiplomeCertificationGetDisplayName(requestParameters: TitreDiplomeCertificationGetDisplayNameRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.titreDiplomeCertificationGetDisplayNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async titreDiplomeCertificationGetSearchCriteriasRaw(requestParameters: TitreDiplomeCertificationGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/TitreDiplomeCertification/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async titreDiplomeCertificationGetSearchCriterias(requestParameters: TitreDiplomeCertificationGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.titreDiplomeCertificationGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async titreDiplomeCertificationGetSelectItemsRaw(requestParameters: TitreDiplomeCertificationGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferentialItemDto>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling titreDiplomeCertificationGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/TitreDiplomeCertification/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferentialItemDtoFromJSON));
    }

    /**
     */
    async titreDiplomeCertificationGetSelectItems(requestParameters: TitreDiplomeCertificationGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferentialItemDto>> {
        const response = await this.titreDiplomeCertificationGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async titreDiplomeCertificationGetTitreDiplomeCertificationRaw(requestParameters: TitreDiplomeCertificationGetTitreDiplomeCertificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TitreDiplomeCertificationEditDto>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/TitreDiplomeCertification`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TitreDiplomeCertificationEditDtoFromJSON(jsonValue));
    }

    /**
     */
    async titreDiplomeCertificationGetTitreDiplomeCertification(requestParameters: TitreDiplomeCertificationGetTitreDiplomeCertificationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TitreDiplomeCertificationEditDto> {
        const response = await this.titreDiplomeCertificationGetTitreDiplomeCertificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async titreDiplomeCertificationSaveTitreDiplomeCertificationRaw(requestParameters: TitreDiplomeCertificationSaveTitreDiplomeCertificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TitreDiplomeCertificationEditDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/TitreDiplomeCertification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TitreDiplomeCertificationEditDtoToJSON(requestParameters.TitreDiplomeCertificationEditDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TitreDiplomeCertificationEditDtoFromJSON(jsonValue));
    }

    /**
     */
    async titreDiplomeCertificationSaveTitreDiplomeCertification(requestParameters: TitreDiplomeCertificationSaveTitreDiplomeCertificationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TitreDiplomeCertificationEditDto> {
        const response = await this.titreDiplomeCertificationSaveTitreDiplomeCertificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
